import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardSyncComponent } from './dashboard-sync/dashboard-sync.component';

const routes: Routes = [
  { path: 'dashboard-sync', component: DashboardSyncComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DatavisualizationRoutingModule { }
